"use client";
import Link from "next/link";
import { ArrowRight, User, Mic, FileText, BarChart3, BookOpen, Users } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { executiveProfile as data } from "@/lib/data/press";

const accent = "var(--color-crimson)";

export function ExecutiveProfile() {
  return (
    <Section id="executive-profile" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-crimson)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <Reveal delay={100}>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {data.leadership.map((l) => (
              <div key={l.role} className="glass rounded-2xl p-5" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                <div className="flex items-center gap-3">
                  <span className="grid place-items-center h-9 w-9 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                    <User className="h-4 w-4" style={{ color: accent }} />
                  </span>
                  <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{l.role}</span>
                </div>
                <div className="mt-2 text-sm font-semibold">{l.name}</div>
                <p className="mt-2 text-xs text-[rgb(var(--fg-muted))] leading-relaxed">{l.expertise}</p>
              </div>
            ))}
          </div>
        </Reveal>
        <div className="mt-8 grid lg:grid-cols-2 gap-5">
          <Reveal delay={200}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <Mic className="h-4 w-4" style={{ color: accent }} />
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Media Availability</span>
              </div>
              <ul className="mt-4 space-y-1.5">
                {data.availability.map((a, i) => (
                  <li key={i} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{a}</li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={250}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <BookOpen className="h-4 w-4" style={{ color: accent }} />
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Executive Expertise Areas</span>
              </div>
              <ul className="mt-4 space-y-1.5">
                {data.expertise.map((e, i) => (
                  <li key={i} className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{e}</li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
